/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import LoadingPage from "components/LoadingPage";

import { connect } from "react-redux";
import { VERIFY_DEVICE_SHOW_TYPE } from "config/constant";
import { getCRMShopInfoSplashDetail } from "store/actions/HomePageAction";
import { getListCampaignSplashAction } from "store/actions/SpecialOfferPageAction";
import { REDIRECT_CHANGE_PASSWORD } from "config/constant";
import { objectToQueryString } from "config/constant";
import { useHistory } from "react-router-dom";
import { getIsSkip } from "utils/utils";

const SplashPage = props => {
	const history = useHistory();
	const searchUrl = history.location.search;
	const getQueryParam = name => new URLSearchParams(searchUrl).get(name);

	const { getCRMShopInfoSplashDetail, getListCampaignSplash } = props;

	const token = getQueryParam("token");
	const type = getQueryParam("type");
	const typeDevice = getQueryParam("typeDevice");
	const message = getQueryParam("message");
	const id = getQueryParam("id");
	const isApp = getQueryParam("isApp");

	const pl = getQueryParam("pl"); //getSystemName
	const av = getQueryParam("av"); //getVersion
	const did = getQueryParam("did"); //getDeviceId
	const osv = getQueryParam("osv"); //getSystemVersion
	const buildVer = getQueryParam("buildVer"); //getBuildNumber
	const uid = getQueryParam("uid"); //getUniqueId
	const modelName = getQueryParam("modelName"); //getNameDevice

	const infoDevice = {
		pl,
		av,
		did,
		osv,
		buildVer,
		uid,
		modelName,
		typeDevice
	};

	const setParamsLocalStorage = async token => {
		await localStorage.setItem("token", token);
		await localStorage.setItem("isApp", isApp);
		await localStorage.setItem("infoDevice", JSON.stringify(infoDevice));
	};

	const checkTokenDiffrent = token => {
		// Check and remove isSkipChangePassword if user loggin again.
		const tokenAfter = localStorage.getItem("token");
		if (token !== tokenAfter) {
			localStorage.removeItem("isSkipChangePassword");
		}
	};

	const redirect = url => {
		history.push(url, { prevUrl: "splash" });
	};

	const handleNotificationLoyalty = business => {
		const onSuccess = data => {
			const loyaltyDetail = data?.find(item => item?.id == id);
			const loyaltyType = loyaltyDetail?.type;
			if (loyaltyType === "GIFT") {
				redirect(`special_offer?id=${id}&type=GIFT`);
				return;
			}
			if (["ACCUMULATE_POINT", "EXCHANGE_POINT"].includes(loyaltyType)) {
				redirect(`/special_offer_detail?id=${id}`);
				return;
			}
			redirect(`/home`);
		};
		const params = {
			business,
			token,
			infoDevice,
			onSuccess
		};
		getListCampaignSplash(params);
	};

	const renderNotificationFollowType = (type, id, business) => {
		switch (type) {
			case "CHANGE_ORDER_STATUS":
			case "CRM_ORDER": {
				redirect(`order_history_detail?id=${id}&business=${business}`);
				break;
			}
			case "PROMOTION": {
				redirect(`/promotion_detail?id=${id}`);
				break;
			}
			case "MERCHANDISING_IMAGE": {
				redirect("/special_offer");
				break;
			}
			case "MERCHANDISING": {
				redirect(`/merchandising_detail?id=${id}`);
				break;
			}
			case "NEW":
			case "UPDATE_SYSTEM":
			case "FORCE_UPDATE": {
				redirect(`news?id=${id}&business=${business}`);
				break;
			}
			case "LOYALTY": {
				handleNotificationLoyalty(business);
				break;
			}
			default:
				redirect("/home");
				break;
		}
	};

	const handleDataProcessing = dataInfo => {
		const passwordType = dataInfo?.passwordType;
		const business = dataInfo?.business;
		const statusDevice = typeDevice || dataInfo?.statusRegisterDevice;
		const isVerify = VERIFY_DEVICE_SHOW_TYPE.includes(statusDevice);
		const isAboutToExpire = passwordType === "ABOUT_TO_EXPIRE";
		const isChangePass = REDIRECT_CHANGE_PASSWORD.includes(passwordType);
		const isSkip = getIsSkip();

		if (isVerify) {
			const params = {
				...infoDevice,
				typeDevice: statusDevice
			};
			if (message) {
				params.message = message;
			}
			const searchQuery = objectToQueryString(params);
			history.push(`/verify-device?${searchQuery}`);
			return;
		}

		if (isChangePass) {
			if (isAboutToExpire && !isSkip) {
				localStorage.setItem("isSkipChangePassword", true);
				history.push("/change_password");
				return;
			}
			if (isAboutToExpire && isSkip) {
				renderNotificationFollowType(type, id, business);
				return;
			}
			history.push("/change_password");
			return;
		}

		if (!!type) {
			renderNotificationFollowType(type, id, business);
			return;
		}
		history.push("/home");
		return;
	};

	const getCRMInfo = token => {
		const onSuccess = data => {
			if (!!data) {
				handleDataProcessing(data);
			}
		};
		const getData = {
			token,
			infoDevice,
			onSuccess
		};
		getCRMShopInfoSplashDetail(getData);
	};

	const initialGetDataSplashPage = async token => {
		if (token) {
			await checkTokenDiffrent(token);
			await setParamsLocalStorage(token);
			await getCRMInfo(token);
		}
	};

	useEffect(() => {
		initialGetDataSplashPage(token);
	}, [searchUrl]);

	return <LoadingPage />;
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		getCRMShopInfoSplashDetail: params => {
			dispatch(getCRMShopInfoSplashDetail(params));
		},
		getListCampaignSplash: params => {
			dispatch(getListCampaignSplashAction(params));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SplashPage);
